import { api } from '../configs/axiosConfigs';

const FORM_PREFIX_URL = 'itau-jn6-app-contas-loja-api';

const otp = {
  resendOTP: async function (detail) {
    const { status, message, statusCode } = detail;

    const response = await api.request({
      url: `${FORM_PREFIX_URL}/forms/resend_otp/`,
      method: 'PATCH',
      data: {
        'flow-name': 'flow-loja-contas-completo',
        data: {
          status,
          message,
          'status-code': statusCode,
        },
      },
    });

    return response;
  },
};

export default { ...otp };
